import React, { Component } from 'react'
import { connect } from 'react-redux'
import { fromJS } from 'immutable'
import Link from 'react-router/lib/Link'
import { actions } from 'react-redux-form/immutable'

import Loading from 'components/Loading'

import { fetchBilling } from './actions'
import FormHeader from './form-header'
import SubjectSummary from './subject-summary'
import BillingDetails from './billing-details'

class BillingShow extends Component {

  render() {
    const { __pending, __data, params } = this.props
    if (__pending || __data.size === 0) {
      return <Loading />
    }

    return (
      <div>
        <div className="m-b-20 text-right">
          <Link to={`/print/billing/${params.studentID}`} target="_blank" className="btn btn-warning">Print Billing</Link>
        </div>
        <FormHeader data={__data.get('header')} />
        <div className="row">
          <div className="col-sm-6">
            <SubjectSummary data={__data.get('subjects')} total={__data.getIn(['meta', 'total_units'])} />
          </div>
          <div className="col-sm-6">
            <BillingDetails data={__data} />
          </div>
        </div>
      </div>
    )
  }
}

BillingShow.onEnter = (store) => (nextState) => store.dispatch(fetchBilling(nextState.params.studentID))
  .then((res) => {
    if (!res.error) {
      store.dispatch(actions.change('billingHeaderState', fromJS(res.payload.header || {})))
    }
  })

function mapStateToProps(state) {
  return {
    __pending: state.billing.get('pending'),
    __data: state.billing.get('item'),
  }
}

export default connect(mapStateToProps)(BillingShow)
/*
import React, { Component, PropTypes } from 'react'
import { connect } from 'react-redux'
import Link from 'react-router/lib/Link'
import { actions } from 'react-redux-form/immutable'
import { fromJS } from 'immutable'

import Loading from 'components/Loading'

import FormAdvising from './form-advising'
import ListEnrolled from './list-enrolled'
import { fetchBilling } from './actions'

class BillingShow extends Component {

  render() {
    const { __pending, __item, params } = this.props

    if (__pending) {
      return <Loading />
    }

    return (
      <div>
        <div className="m-b-20 text-right">
          <Link to={`/print/billing/${params.studentID}`} target="_blank" className="btn btn-warning">Print Billing</Link>
        </div>
        <FormAdvising />
        <ListEnrolled />
      </div>
    )
  }
}

BillingShow.onEnter = (store) => (nextState) => {
  store.dispatch(fetchBilling(Number(nextState.params.studentID)))
    .then((res) => {
      if (res && !res.error) {
        store.dispatch(actions.change('advisingState', fromJS(res.payload.advising || {})))
        store.dispatch(actions.change('enrolledState', fromJS(res.payload.subjects || [])))
      }
    })
}

BillingShow.propTypes = {
  __pending: PropTypes.bool,
  __item: PropTypes.object,
}

function mapStateToProps(state) {
  return {
    __pending: state.enrolment.get('pending'),
    __item: state.enrolment.get('item'),
  }
}
export default connect(mapStateToProps)(BillingShow)
*/



// WEBPACK FOOTER //
// ./src/containers/Billing/show.js